import { initializeApp, getApps } from 'firebase/app';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

/**
 * Ist die Firebase-Konfiguration vollständig?
 *
 * Warum diese Prüfung überhaupt: getAuth() wirft bei fehlendem Schlüssel
 * ein hartes `auth/invalid-api-key`. Da der AuthProvider die gesamte App
 * umschließt, würde das die KOMPLETTE Seite auf eine weiße Fläche
 * reduzieren - auch Impressum und Datenschutz, die nach deutschem Recht
 * erreichbar sein müssen. Fehlt die Konfiguration (noch kein Firebase-Projekt,
 * vergessene .env.local, kaputtes CI-Secret), läuft die öffentliche Seite
 * deshalb weiter; nur Anmeldung und Live-Daten sind dann still abgeschaltet.
 */
export const isFirebaseConfigured = Object.values(firebaseConfig).every(
  (value) => typeof value === 'string' && value.length > 0
);

let app = null;

if (isFirebaseConfigured) {
  // Verhindert doppelte Initialisierung beim Hot-Reload
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
} else if (process.env.NODE_ENV !== 'test') {
  console.warn(
    '[firebase] Konfiguration unvollständig - Anmeldung und Live-Daten sind deaktiviert. ' +
      'Bitte REACT_APP_FIREBASE_* in .env.local setzen (siehe README).'
  );
}

export default app;
